<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue';

const KIND_FILENAMES: Record<string, string> = {
    INIT: '__init__.py',
    FILTERS: 'filters.py',
    MODELS: 'models.py',
    REFERENCE_UNITS: 'reference_units.py',
    REGISTER: 'register.py',
    REPO: 'repository.py',
    STRATEGIES: 'strategies.py',
    TOOLS: 'tools.py',
    TYPE: 'type.py',
    REFERENCES_VIEW: 'ReferencesView.js',
    RAW_VIEW: 'RawView.js',
};

interface TypeFileProp {
    record_id: string;
    kind: string;
    text: string;
    language?: string;
}

const props = defineProps<{
    file: TypeFileProp | null;
}>();

const emit = defineEmits<{ close: [] }>();

const codeEl = ref<HTMLElement | null>(null);

const language = computed(() => props.file?.language || 'plaintext');

watch(
    () => props.file,
    async () => {
        if (!props.file) return;
        await nextTick();
        const hljs = (
            window as unknown as { hljs?: { highlightElement: (el: HTMLElement) => void } }
        ).hljs;
        if (codeEl.value && hljs) {
            codeEl.value.removeAttribute('data-highlighted');
            hljs.highlightElement(codeEl.value);
        }
    },
    { immediate: true },
);

function filename(file: TypeFileProp) {
    return KIND_FILENAMES[file.kind] ?? file.kind;
}

function close() {
    emit('close');
}
</script>

<template>
    <div v-if="file" class="type-file-drawer-overlay" @click.self="close">
        <div class="type-file-drawer">
            <div class="type-file-drawer-header">
                <span class="type-file-drawer-title">{{ filename(file) }}</span>
                <span class="material-icons type-file-drawer-close" @click="close">close</span>
            </div>
            <div class="type-file-drawer-body">
                <pre><code ref="codeEl" :class="'language-' + language">{{ file.text }}</code></pre>
            </div>
        </div>
    </div>
</template>
